import React, { Fragment, useState } from 'react';
import { Container } from 'react-bootstrap';
import HeaderLogged from '../../../../../components/header_logged'
import Footer from '../../../../../components/footer'
import Head from '../../../../../components/head';
import Listar from '../../../../../components/auth/rh/terceirizados/listar'


function TerceirizadoSaudeScreen() {

    return (
        <Fragment>
            <Head titulo="Listagem de Estagiários - Recursos Humanos" />
            <HeaderLogged />
            <Container>
               <Listar />
            </Container>
            <Footer />
        </Fragment>
    );
}

export default TerceirizadoSaudeScreen;